import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const CopyIcon = forwardRef<SVGSVGElement, IconProps>(function LockIcon(
  { color = '', height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.7723 13.8948C1.58415 13.0482 1.50001 11.9182 1.50001 10.3847C1.50001 8.85108 1.58415 7.7211 1.7723 6.8745C1.95667 6.04493 2.22038 5.58219 2.51666 5.28592C2.81294 4.98965 3.27569 4.72594 4.10528 4.54158C4.9519 4.35343 6.08191 4.2693 7.61552 4.2693C9.14913 4.2693 10.2791 4.35343 11.1258 4.54158C11.9553 4.72594 12.4181 4.98965 12.7144 5.28592C13.0107 5.58219 13.2744 6.04493 13.4587 6.8745C13.6469 7.7211 13.731 8.85108 13.731 10.3847C13.731 11.9182 13.6469 13.0482 13.4587 13.8948C13.2744 14.7244 13.0107 15.1871 12.7144 15.4834C12.4181 15.7797 11.9553 16.0434 11.1258 16.2277C10.2791 16.4159 9.14913 16.5 7.61552 16.5C6.08191 16.5 4.9519 16.4159 4.10528 16.2277C3.27569 16.0434 2.81294 15.7797 2.51666 15.4834C2.22038 15.1871 1.95667 14.7244 1.7723 13.8948ZM7.61552 18C1.34414 18 0 16.6559 0 10.3847C0 4.11341 1.34414 2.7693 7.61552 2.7693C13.8869 2.7693 15.231 4.11341 15.231 10.3847C15.231 16.6559 13.8869 18 7.61552 18Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2048 11.7641C15.1791 12.3767 15.1335 12.9322 15.063 13.4355C17.3972 12.7219 18 10.9273 18 6.92304C18 1.38461 16.6154 0 11.0768 0C7.07218 0 5.27756 0.60287 4.56409 2.93744C5.0673 2.86692 5.62278 2.82126 6.23542 2.79557C6.33085 2.62115 6.43303 2.48913 6.5379 2.38426C6.78327 2.13889 7.1773 1.90827 7.91526 1.74427C8.67025 1.57649 9.68572 1.49999 11.0768 1.49999C13.8568 1.49999 14.9932 1.88382 15.5547 2.44527C16.1162 3.00672 16.5 4.14311 16.5 6.92304C16.5 8.31409 16.4235 9.32954 16.2557 10.0845C16.0917 10.8224 15.8611 11.2165 15.6157 11.4618C15.5109 11.5666 15.379 11.6687 15.2048 11.7641Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
